import { UserApi } from '@shared/services/users';

export const readMeUsersMock = (): UserApi => ({
  userId: 'jean.doe@test.fr',
  firstName: 'Jean',
  lastName: 'Doe',
  role: 'STORE_MANAGER',
  annuaire: 'franchise',
  permissions: {
    canGenerateVideo: true,
    canManageVideoQuotas: true,
    canGenerateImage: true,
    imageBlockedReason: null,
    imageAvailableAt: null,
  },
  access: {
    type: 'USAGE_BASED',
    currentMonth: {
      images: 156,
      videos: 12,
      amount: 47.32,
    },
  },
  isBusinessNumberRequired: true,
});
